import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { fetchTopicIndex, slimTopicForClient } from "@/lib/topics.server";

export const getTopicIndex = createServerFn({ method: "GET" })
  .inputValidator((data) => z.object({ slug: z.string() }).parse(data))
  .handler(async ({ data }) => slimTopicForClient(await fetchTopicIndex(data.slug)));
